<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Link product') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row" v-if="isTypeSelectionAvailable">
        <div class="col-xs-12">
          <div class="form-group">
            <label>{{ _('Product option type') }}</label>
            <div class="flex-row">
              <button v-if="linkedProductType === null || linkedProductType === LINKEDPRODUCT_MANDATORY" class="btn btn-success" style="min-height: 50px; width: 24%" v-on:click="selectType(LINKEDPRODUCT_MANDATORY)"><i class="fa fa-fw fa-gavel"></i> {{ _('Mandatory') }}</button>
              <button v-if="linkedProductType === null || linkedProductType === LINKEDPRODUCT_HIDDEN" class="btn btn-success" style="min-height: 50px; width: 24%" v-on:click="selectType(LINKEDPRODUCT_HIDDEN)"><i class="fa fa-fw fa-eye-slash"></i> {{ _('Hidden') }}</button>
              <button v-if="linkedProductType === null || linkedProductType === LINKEDPRODUCT_OPTIONAL" class="btn btn-success" style="min-height: 50px; width: 24%" v-on:click="selectType(LINKEDPRODUCT_OPTIONAL)"><i class="fa fa-fw fa-plus"></i> {{ _('Optional') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="isProductSelectorVisible">
        <div class="col-md-12">
          <div class="form-group">
            <label for="product">{{ _('Product') }}</label><br />
            <v-select :options="products" v-model="product" label="name" keys="['id', 'name']" :placeholder="_('Type to search products')" :create-item="false">
              <template v-slot:no-options="{ searching }">
                <template v-if="searching">
                  {{ _('No results found.') }}
                </template>
                <template v-else>{{ _('Type to search products') }}</template>
              </template>
              <template v-slot:option="option">
                <div class="d-center">
                  <span>{{ option.id }}: {{ option.name }}</span><span class="item-type to-right">{{ formatType(option) }}</span>
                </div>
              </template>
              <template v-slot:selected-option="option">
                <div class="selected d-center">
                  {{ option.id }}: {{ option.name }}
                </div>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="row" v-if="isOptionGroupSelectorVisible">
        <div class="col-md-12">
          <div class="form-group">
            <label for="optionGroup">{{ _('Choice group') }}</label><br />
            <select class="form-control" id="optionGroup" v-model="optiongroup">
              <option value="">{{ _('No choice group') }}</option>
              <option v-for="optionGroup in optionGroups" :value="optionGroup.ref">{{ optionGroup.name || _('Unnamed choice group') }}</option>
            </select>
            <p class="help-block">{{ _('The customer can pick only one option from a choice group.') }}</p>
          </div>
        </div>
      </div>
      <template v-if="isGroupSelectorVisible">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="multiplyParticipant">{{ _('Number of products per participant') }}</label><br />
              <input type="number" min="1" class="form-control" id="multiplyParticipant" v-model="multiplyparticipant" /> 
            </div>
          </div>
        </div>
        <hr />
        <div class="row" style="margin-top: 15px">
          <div class="col-md-12">
            <div class="form-group">
              <label for="selectorGroup">{{ _('Selection group') }}</label><br />
              <v-select :options="existingGroups" v-model="group" :taggable="true" input-id="selectorGroup" :placeholder="_('Type to search or create a selection group')">
                <template v-slot:no-options="{ searching }">
                  <template v-if="searching">
                    {{ _('No results found. Press enter to create a new group.') }}
                  </template>
                  <template v-else>{{ _('Type to search or create a selection group') }}</template>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <div>
                <label>
                  <input type="checkbox" name="requireparticipant" v-model="requireparticipant" :true-value="1" :false-value="0"> <template v-if="group">{{ _('One product from the group required for each participant') }}</template><template v-else>{{ _('Required for each participant') }}</template>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
      <hr v-if="isMultiplyVisible || isTimeRangeVisible" />
      <div class="row multiplySelectors" style="margin-top: 15px" v-if="isMultiplyVisible">
        <div class="col-xs-12" v-if="isCountSelectionVisible">
          <label>{{ _('Count selection') }}</label>
          <div>
            <div>
              <label>
                <input type="radio" name="countselection" v-model="countSelection" value="selectable"> {{ _('Selectable by the customer') }}
              </label>
            </div>
            <div>
              <label>
                <input type="radio" name="countselection" v-model="countSelection" value="multiply"> {{ _('Set automatically') }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-xs-12" v-else>
          <label>{{ _('Count selection') }}</label>
          <div>
            <div>
              <label>
                <input type="radio" name="countselection" v-model="countSelection" value="multiply"> {{ _('Set automatically') }}
              </label>
            </div>
          </div>
        </div>
        <hr />
        <div class="col-xs-12" v-if="areMultiplySelectorsVisible">
          <div>
            <label>{{ _('Multiply the product count') }}</label>
            <template v-if="isParentReservable">
              <div>
                <label>
                  <input type="checkbox" name="linkedproductmultiply" v-model="multiply" value="days"> {{ _('By the number of days') }}
                </label>
              </div>
              <div>
                <label>
                  <input type="checkbox" name="linkedproductmultiply" v-model="multiply" value="participants"> {{ _('By the number of participants') }}
                </label>
              </div>
              <div>
                <label>
                  <input type="checkbox" name="linkedproductmultiply" v-model="multiply" value="resources"> {{ _('By the number of resources') }}
                </label>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="row timerangeSelectors" style="margin-top: 15px" v-if="isTimeRangeVisible">
        <div class="col-xs-12">
          <label>{{ _('Relation to the parent reservation') }}</label>
          <div>
            <div>
              <label>
                <input type="radio" name="timerange" v-model="timerange" value="match"> {{ _('Match the reservation\'s start and end times') }}
              </label>
            </div>
            <div>
              <label>
                <input type="radio" name="timerange" v-model="timerange" value="offset" v-on:change="timeRangeChanged"> {{ _('Offset the reservation\'s start or end times') }}
              </label>
            </div>
            <div>
              <label>
                <input type="radio" name="timerange" v-model="timerange" value="fixed" v-on:change="timeRangeChanged"> {{ _('Use fixed start and end times') }}
              </label>
            </div>
            <div v-if="isFreelySelectableAvailable">
              <label>
                <input type="radio" name="timerange" v-model="timerange" value="unrestricted" v-on:change="timeRangeChanged"> {{ _('Freely selectable within the reservation\'s start and end times') }}
              </label>
              <select class="form-control" v-model="startOffsetMode" v-if="timerange === 'unrestricted'">
                <option value="afterstart">{{ _('Use day precision') }}</option>
                <option value="exact">{{ _('Use exact times') }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-xs-12" v-if="isFixedVisible">
          <label>{{ _('Start the reservation') }}</label>
          <div class="form-inline">
            <div class="form-group" v-if="!parseInt(repeat)">
              <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
            </div>
            <div class="form-group">
              <TimePicker :tz="Intl.DateTimeFormat().resolvedOptions().timeZone" v-model="timeStart" :shortLocale="shortLocale"></TimePicker>
            </div>
          </div>
          <label>{{ _('End the reservation') }}</label>
          <div class="form-inline">
            <div class="form-group" v-if="!parseInt(repeat)">
              <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
            </div>
            <div class="form-group">
              <TimePicker :tz="Intl.DateTimeFormat().resolvedOptions().timeZone" v-model="timeEnd" :shortLocale="shortLocale"></TimePicker>
            </div>
          </div>
          <div>
            <label>
              <input type="checkbox" name="linkedproductmultiply" v-model="repeat" true-value="1" false-value="0"> {{ _('Repeat daily during the reservation') }}
            </label>
          </div>
        </div>
        <div class="col-xs-12" v-if="isOffsetVisible">
          <div class="form-group">
            <label>{{ _('Start the reservation') }}</label>
            <div class="input-group">
              <input type="text" class="form-control" id="startOffsetDays" v-model="startOffsetDays" /> 
              <div class="input-group-addon">{{ _('d') }}</div>
              <input type="text" class="form-control" id="startOffsetHours" v-model="startOffsetHours" /> 
              <div class="input-group-addon">{{ _('h') }}</div>
              <input type="text" class="form-control" id="startOffsetMinutes" v-model="startOffsetMinutes" /> 
              <div class="input-group-addon">{{ _('min') }}</div>
              <div class="input-group-btn">
                <Dropdown buttonClass="btn-default" menuClass="dropdown-menu-right" direction="up">
                  <template #trigger>
                    <span v-html="startOffsetModeDesc"></span> <span class="caret"></span>
                  </template>
                  <li><a v-on:click="setStartOffsetMode('beforestart')">{{ _('before the parent reservation starts') }}</a></li>
                  <li><a v-on:click="setStartOffsetMode('afterstart')">{{ _('after the parent reservation starts') }}</a></li>
                  <li><a v-on:click="setStartOffsetMode('beforeend')">{{ _('before the parent reservation ends') }}</a></li>
                  <li><a v-on:click="setStartOffsetMode('afterend')">{{ _('after the parent reservation ends') }}</a></li>
                </Dropdown>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>{{ _('End the reservation') }}</label>
            <div class="input-group">
              <input type="text" class="form-control" id="endOffsetDays" v-model="endOffsetDays" /> 
              <div class="input-group-addon">{{ _('d') }}</div>
              <input type="text" class="form-control" id="endOffsetHours" v-model="endOffsetHours" /> 
              <div class="input-group-addon">{{ _('h') }}</div>
              <input type="text" class="form-control" id="endOffsetMinutes" v-model="endOffsetMinutes" /> 
              <div class="input-group-addon">{{ _('min') }}</div>
              <div class="input-group-btn">
                <Dropdown buttonClass="btn-default" menuClass="dropdown-menu-right">
                  <template #trigger>
                    <span v-html="endOffsetModeDesc"></span> <span class="caret"></span>
                  </template>
                  <li><a v-on:click="setEndOffsetMode('beforestart')" v-if="isEndOffsetAvailable('beforestart')">{{ _('before the parent reservation starts') }}</a></li>
                  <li><a v-on:click="setEndOffsetMode('afterstart')" v-if="isEndOffsetAvailable('afterstart')">{{ _('after the parent reservation starts') }}</a></li>
                  <li><a v-on:click="setEndOffsetMode('beforeend')" v-if="isEndOffsetAvailable('beforeend')">{{ _('before the parent reservation ends') }}</a></li>
                  <li><a v-on:click="setEndOffsetMode('afterend')" v-if="isEndOffsetAvailable('afterend')">{{ _('after the parent reservation ends') }}</a></li>
                  <li><a v-on:click="setEndOffsetMode('fixed')">{{ _('after it starts') }}</a></li>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="isIncludeInPriceVisible" />
      <div class="row" v-if="isIncludeInPriceVisible">
        <div class="col-xs-12">
          <div>
            <label>
              <input type="checkbox" name="includeinprice" v-model="includeinprice" true-value="1" false-value="0"> {{ _('Included in the main product price') }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectProduct" :disabled="isValidSelection ? undefined : true"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'
import formatters from '~/lib/formatters'
import { DateTime } from 'luxon'

export default {
  props: ['selectedProducts', 'parentType', 'linkedProduct', 'forceType', 'existingGroups', 'optionGroups', 'optiongroupRef'],
  mixins: [constants, formatters],
  data () {
    return {
      product: null,
      products: [],
      linkedProductType: null,
      multiply: [],
      includeinprice: 0,
      countSelection: 'selectable',
      timerange: 'match',
      startOffset: 0,
      startOffsetMode: 'afterstart',
      endOffset: 0,
      endOffsetMode: 'beforeend',
      dateStart: null,
      dateEnd: null,
      timeStart: null,
      timeEnd: null,
      repeat: 0,
      requireparticipant: 1,
      multiplyparticipant: 1,
      group: '',
      optiongroup: ''
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey', 'locale', 'dateFormat', 'timeFormat', 'timezone']),
    shortLocale () {
      return this.locale.split('_')[0]
    },
    isValidSelection () {
      if (this.timerange === 'fixed') {
        if (!this.timeStart || !this.timeEnd) {
          return false
        }
        if (!parseInt(this.repeat) && (!this.dateStart || !this.dateEnd)) {
          return false
        }
      }
      if (this.timerange === 'unrestricted') {
        if (this.startOffsetMode !== 'exact' && this.startOffsetMode !== 'afterstart') {
          return false
        }
      }
      return true
    },
    hasGroup () {
      return !!this.group
    },
    isTypeSelectionAvailable () {
      return this.linkedProductType === null || (this.linkedProductType !== this.LINKEDPRODUCT_OFFER && this.linkedProductType !== this.LINKEDPRODUCT_PACKAGED)
    },
    startOffsetModeDesc () {
      return this.getOffsetModeDesc(this.startOffsetMode)
    },
    endOffsetModeDesc () {
      return this.getOffsetModeDesc(this.endOffsetMode)
    },
    selectedProductIds () {
      return this.selectedProducts.map(l => l.id)
    },
    isGroupSelectorVisible () {
      return this.linkedProductType === this.LINKEDPRODUCT_PACKAGED
    },
    isOptionGroupSelectorVisible () { // Activity pricing: only optional options can be placed in a choice group
      return !!(this.optionGroups && this.optionGroups.length) && this.linkedProductType === this.LINKEDPRODUCT_OPTIONAL && !!this.product
    },
    isMultiplyVisible () {
      return this.linkedProductType != this.LINKEDPRODUCT_OFFER && this.linkedProductType !== this.LINKEDPRODUCT_PACKAGED && !!this.product && (parseInt(this.product.type) === this.TYPE_BUYABLE || this.timerange === 'match' || this.timerange === 'offset' || this.timerange === 'fixed')
    },
    isCountSelectionVisible () {
      return this.linkedProductType !== this.LINKEDPRODUCT_HIDDEN
    },
    isIncludeInPriceVisible() {
      return this.isMandatory && this.countSelection === 'multiply' && this.timerange !== 'unrestricted'
    },
    areMultiplySelectorsVisible () {
      return this.linkedProductType != this.LINKEDPRODUCT_OFFER && this.linkedProductType !== this.LINKEDPRODUCT_PACKAGED && this.countSelection === 'multiply' && this.product && parseInt(this.product.type) === this.TYPE_BUYABLE && this.isParentReservable
    },
    isParentReservable() {
      return parseInt(this.parentType) === this.TYPE_RESERVABLE
    },
    isParentBuyable() {
      return parseInt(this.parentType) === this.TYPE_BUYABLE
    },
    isTimeRangeVisible () {
      return this.linkedProductType != this.LINKEDPRODUCT_OFFER && this.linkedProductType !== this.LINKEDPRODUCT_PACKAGED && this.isParentReservable && this.product && parseInt(this.product.type) === this.TYPE_RESERVABLE && this.linkedProductType !== this.LINKEDPRODUCT_OFFER
    },
    isMandatory() {
      return this.linkedProductType === this.LINKEDPRODUCT_MANDATORY
    },
    isFreelySelectableAvailable () {
      return this.linkedProductType === this.LINKEDPRODUCT_OPTIONAL || this.linkedProductType === this.LINKEDPRODUCT_MANDATORY
    },
    isProductSelectorVisible () {
      return this.linkedProductType !== null
    },
    isReservableProduct () {
      if (!this.product) {
        return false
      }
      return parseInt(this.product.type) === this.TYPE_RESERVABLE
    },
    shouldLoadAllProducts () {
      return this.linkedProductType === this.LINKEDPRODUCT_OFFER || this.linkedProductType === this.LINKEDPRODUCT_PACKAGED || this.isParentReservable || this.linkedProductType !== this.LINKEDPRODUCT_HIDDEN
    },
    isOffsetVisible () {
      return this.timerange === 'offset'
    },
    isFixedVisible () {
      return this.timerange === 'fixed'
    },
    startOffsetDays: {
      get () {
        return Math.floor(this.startOffset / 24)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.startOffset = Math.abs(v) * 24 + this.startOffsetHours + this.startOffsetMinutes / 60
      }
    },
    startOffsetHours: {
      get () {
        return Math.floor(this.startOffset - this.startOffsetDays * 24)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.startOffset = this.startOffsetDays * 24 + Math.abs(v) + this.startOffsetMinutes / 60
      }
    },
    startOffsetMinutes: {
      get () {
        return Math.round((this.startOffset - this.startOffsetDays * 24 - this.startOffsetHours) * 60)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.startOffset = this.startOffsetDays * 24 + this.startOffsetHours + Math.abs(v) / 60
      }
    },
    endOffsetDays: {
      get () {
        return Math.floor(this.endOffset / 24)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.endOffset = Math.abs(v) * 24 + this.endOffsetHours + this.endOffsetMinutes / 60
      }
    },
    endOffsetHours: {
      get () {
        return Math.floor(this.endOffset - this.endOffsetDays * 24)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.endOffset = this.endOffsetDays * 24 + Math.abs(v) + this.endOffsetMinutes / 60
      }
    },
    endOffsetMinutes: {
      get () {
        return Math.round((this.endOffset - this.endOffsetDays * 24 - this.endOffsetHours) * 60)
      },
      set (newValue) {
        let v = parseInt(newValue, 10)
        if (!v) {
          v = 0
        }
        this.endOffset = this.endOffsetDays * 24 + this.endOffsetHours + Math.abs(v) / 60
      }
    },
  },
  watch: {
    shouldLoadAllProducts: {
      handler(newValue) {
        this.loadProducts()
      }
    },
    dateStart: {
      handler(newValue) {
        this.updateStartOffset()
      }
    },
    dateEnd: {
      handler(newValue) {
        this.updateEndOffset()
      }
    },
    timeStart: {
      handler(newValue) {
        this.updateStartOffset()
      }
    },
    timeEnd: {
      handler(newValue) {
        this.updateEndOffset()
      }
    },
    startOffsetMode: {
      handler(newValue) {
        if (!this.isEndOffsetAvailable(this.endOffsetMode)) {
          this.endOffsetMode = newValue
        }
      }
    },
    repeat: {
      handler(newValue) {
        if (parseInt(newValue)) {
          this.dateStart = null
          this.dateEnd = null
        }
      }
    },
    product: {
      handler(newValue) {
        if (newValue && this.linkedProductType === this.LINKEDPRODUCT_HIDDEN) {
          this.countSelection = 'multiply'
        }
      }
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    isEndOffsetAvailable(mode) {
      switch (mode) {
        case 'beforestart':
          return this.startOffsetMode !== 'afterend' && this.startOffsetMode !== 'beforeend' && this.startOffsetMode !== 'afterstart'
        case 'afterstart':
          return this.startOffsetMode !== 'afterend' && this.startOffsetMode !== 'beforeend'
        case 'beforeend':
          return this.startOffsetMode !== 'afterend'
        case 'afterend':
          return true
        case 'fixed':
          return true
      }
      return false
    },
    getOffsetModeDesc(mode) {
      switch (mode) {
        case 'beforestart':
          return this._('before the parent reservation starts')
        case 'afterstart':
          return this._('after the parent reservation starts')
        case 'beforeend':
          return this._('before the parent reservation ends')
        case 'afterend':
          return this._('after the parent reservation ends')
        case 'fixed':
          return this._('after it starts')
      }
      return ''
    },
    timeRangeChanged() {
      if (this.timerange === 'fixed' || this.timerange === 'offset') {
        this.startOffset = this.timerange === 'fixed' ? null : 0
        this.endOffset = this.timerange === 'fixed' ? null : 0
        this.dateStart = null
        this.dateEnd = null
        this.timeStart = null
        this.timeEnd = null
      }
      if (this.timerange === 'offset') {
        this.startOffsetMode = 'afterstart'
        this.endOffsetMode = 'beforeend'
      }
      if (this.timerange === 'unrestricted') {
        this.startOffsetMode = 'afterstart'
      }
    },
    updateStartOffset() {
      if (!this.dateStart && !this.timeStart) {
        this.startOffset = null
        return
      }
      const dateStartDT = this.dateStart ? DateTime.fromJSDate(this.dateStart, { zone: this.timezone }) : DateTime.fromISO('1970-01-01', { zone: this.timezone })
      if (this.timeStart) {
        this.startOffset = DateTime.fromObject({ year: dateStartDT.year, month: dateStartDT.month, day: dateStartDT.day, hour: this.timeStart.hours, minute: this.timeStart.minutes, second: 0 }, { zone: this.timezone }).toUnixInteger()
      } else {
        this.startOffset = DateTime.fromObject({ year: dateStartDT.year, month: dateStartDT.month, day: dateStartDT.day, hour: 0, minute: 0, second: 0 }, { zone: this.timezone }).toUnixInteger()
      }
    },
    updateEndOffset() {
      if (!this.dateEnd && !this.timeEnd) {
        this.endOffset = null
        return
      }
      const dateEndDT = this.dateEnd ? DateTime.fromJSDate(this.dateEnd, { zone: this.timezone }) : DateTime.fromISO('1970-01-01', { zone: this.timezone })
      if (this.timeEnd) {
        this.endOffset = DateTime.fromObject({ year: dateEndDT.year, month: dateEndDT.month, day: dateEndDT.day, hour: this.timeEnd.hours, minute: this.timeEnd.minutes, second: 0 }, { zone: this.timezone }).toUnixInteger()
      } else {
        this.endOffset = DateTime.fromObject({ year: dateEndDT.year, month: dateEndDT.month, day: dateEndDT.day, hour: 0, minute: 0, second: 0 }, { zone: this.timezone }).toUnixInteger()
      }
    },
    setLinkedProduct(linkedProduct) {
      this.linkedProductType = parseInt(linkedProduct.type)
      const product = this.products.find(p => parseInt(p.id, 10) === parseInt(linkedProduct.linkedproduct_id, 10))
      if (product) {
        this.product = product
      }
      if (linkedProduct.multiply) {
        if (typeof linkedProduct.multiply === 'string') {
          this.multiply = linkedProduct.multiply.split(',')
        } else {
          this.multiply = linkedProduct.multiply
        }
      }
      if (this.multiply.includes('selectable') && this.linkedProductType !== this.LINKEDPRODUCT_HIDDEN) {
        this.countSelection = 'selectable'
      } else {
        this.countSelection = 'multiply'
      }
      this.includeinprice = linkedProduct.includeinprice
      this.timerange = linkedProduct.timerange
      this.repeat = linkedProduct.repeat
      this.group = linkedProduct.group
      this.requireparticipant = linkedProduct.requireparticipant
      this.multiplyparticipant = linkedProduct.multiplyparticipant
      this.startOffset = linkedProduct.startoffset
      this.startOffsetMode = linkedProduct.startoffsetmode
      this.endOffset = linkedProduct.endoffset
      this.endOffsetMode = linkedProduct.endoffsetmode
      if (linkedProduct.timerange === 'fixed') {
        if (this.startOffset !== null) {
          this.dateStart = this.startOffset > 100000 ? DateTime.fromSeconds(Number(this.startOffset), { zone: this.timezone }).toJSDate() : null
          let timeStart = this.startOffset > 100000 ? DateTime.fromSeconds(Number(this.startOffset), { zone: this.timezone }) : DateTime.fromSeconds(Number(this.startOffset), { zone: this.timezone })
          this.timeStart = {
            hours: timeStart.hour,
            minutes: timeStart.minute,
            seconds: 0
          }
        }
        if (this.endOffset !== null) {
          this.dateEnd = this.endOffset > 100000 ? DateTime.fromSeconds(Number(this.endOffset), { zone: this.timezone }).toJSDate() : null
          let timeEnd = this.endOffset > 100000 ? DateTime.fromSeconds(Number(this.endOffset), { zone: this.timezone }) : DateTime.fromSeconds(Number(this.endOffset), { zone: this.timezone })
          this.timeEnd = {
            hours: timeEnd.hour,
            minutes: timeEnd.minute,
            seconds: 0
          }
        }
      }
    },
    setStartOffsetMode (mode) {
      this.startOffsetMode = mode
    },
    setEndOffsetMode (mode) {
      this.endOffsetMode = mode
    },
    selectType (type) {
      this.product = null
      if (this.linkedProductType === type) {
        this.linkedProductType = null
      } else {
        this.linkedProductType = parseInt(type)
      }
    },
    selectProduct () {
      let multiply
      if (!this.isMultiplyVisible) {
        multiply = ''
      } else if (this.countSelection === 'selectable') {
        multiply = ['selectable']
      } else {
        multiply = this.multiply.filter(m => m !== 'selectable')
      }
      let timerange = this.timerange
      if (!this.isTimeRangeVisible) {
        timerange = ''
      }
      if (this.isReservableProduct && parseInt(this.parentType) === this.TYPE_BUYABLE) {
        timerange = 'unrestricted'
      }
      let includeinprice = this.includeinprice
      if (!this.isIncludeInPriceVisible) {
        includeinprice = 0
      }
      let repeat = this.repeat
      const selection = {
        id: (this.linkedProduct && this.linkedProduct.id ? this.linkedProduct.id : null),
        product: this.product,
        type: this.linkedProductType,
        multiply,
        timerange,
        repeat,
        startOffset: this.startOffset,
        startOffsetMode: this.startOffsetMode,
        endOffset: this.endOffset,
        endOffsetMode: this.endOffsetMode,
        includeinprice,
        group: this.group,
        requireparticipant: this.requireparticipant,
        multiplyparticipant: this.multiplyparticipant,
      }
      if (this.optionGroups) { // Choice groups are only passed in when the shop uses activity pricing
        selection.optiongroup = this.linkedProductType === this.LINKEDPRODUCT_OPTIONAL ? this.optiongroup : ''
      }
      this.$emit('selectProduct', selection)
    },
    loadProducts() {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products.json?iSortingCols=1&iSortCol_0=2&sSortDir_0=asc' + (this.shouldLoadAllProducts ? '' : '&sSearch_3=0') + '&simple=true&apikey=' + this.apiKey)
        } catch(e) {
          resolve([])
          return
        }
        this.products = response.data.filter(product => {
          if (parseInt(product.subtype, 10) === this.SUBTYPE_TICKET) { // Never show tickets by themselves, since they won't work
            return false
          }
          if (this.linkedProductType === this.LINKEDPRODUCT_OFFER) {
            return this.selectedProductIds.indexOf(product.id) === -1 // Only list products that are not already added. AND KEEP FUCKING CONTENT PRODUCTS AS WELL AS THIS IS OFFER ONLY
          } else {
            return parseInt(product.subtype, 10) !== this.SUBTYPE_CONTENT && this.selectedProductIds.indexOf(product.id) === -1 // Only list products that are not already added. AND LEAVE OUT FUCKING CONTENT PRODUCTS AS WELL WHAT THE FUCK TÄDIT JA SEDÄT
          }
        })
        resolve(this.products)
      })
    },
    formatType(product) {
      const cell = {
        getValue () {
          return product.type
        },
        getRow () {
          return {
            getData () {
              return product
            }
          }
        }
      }
      return this.productTypeFormatter()(cell)
    }
  },
  async mounted () {
    if (this.forceType) {
      this.linkedProductType = this.forceType
    }
    if (this.optiongroupRef) {
      this.optiongroup = this.optiongroupRef
    }
    await this.loadProducts()
    if (this.linkedProduct) {
      this.setLinkedProduct(this.linkedProduct)
    }
  }
}
</script>